//X Label detailed function
import * as d3 from "d3";
export function labeledXAxis(selection, props) {
  const {
    xAxisLabelFill,
    xAxisLabelOffset,
    xAxisTickFontSize,
    xAxisLabelFontSize,
    AxisTickFontFill,
    AxisTickLineStroke,
    xScale,
    innerHeight,
    innerWidth,
  } = props;

  const xAxisTickFormat = d3.timeFormat("%d %b");

  let tickCount;
  function widthDetector() {
    if (innerWidth > 400) {
      tickCount = 8;
    } else {
      tickCount = 11;
    }
  }
  widthDetector();

  const xAxis = d3
    .axisBottom(xScale)
    // .ticks(innerWidth / xAxisTickDensity)
    .ticks(d3.timeDay.every(tickCount))
    .tickFormat(function (d) {
      return xAxisTickFormat(d);
    });
  // .tickSizeOuter(0);

  let xAxisG = selection.selectAll(".AxisX").data([null]);
  xAxisG = xAxisG
    .enter()
    .append("g")
    .attr("class", "AxisX")
    .merge(xAxisG)
    .attr("transform", `translate(0, ${innerHeight})`);
  xAxisG.call(xAxis);
  xAxisG
    .selectAll(".tick text")
    .attr("opacity", 1)
    .attr("x", 0)
    .attr("y", "20px")
    .attr("transform", "rotate(0)")
    .attr("text-anchor", "middle")
    .style("font-size", xAxisTickFontSize)
    .attr("fill", AxisTickFontFill);
  xAxisG
    .selectAll(".tick line")
    .attr("stroke", AxisTickLineStroke)
    .attr("y1", "0px")
    .attr("y2", innerHeight)
    .attr("transform", `translate(0, ${-innerHeight})`);
  xAxisG.select(".domain").attr("opacity", 0);

  //Labels
  const xAxisLabel = xAxisG.selectAll(".axisLabelX").data([null]);
  xAxisLabel
    .enter()
    .append("text")
    .attr("class", "axisLabelX")
    .merge(xAxisLabel)
    .attr("opacity", 0)
    .text("Definition of values (%)")
    .attr("text-anchor", "middle")
    .attr("fill", xAxisLabelFill)
    .attr("x", innerWidth - 44)
    .attr("y", xAxisLabelOffset)
    .style("font-size", xAxisLabelFontSize);
}
